// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__TfHr0","section-1":"styles_section-1__UeGYu","content":"styles_content__aHETq","section-2":"styles_section-2__rzytG"};